import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/wallet/transaction.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getTransactionById = (_0) => __async(void 0, [_0], function* ({ transactionId, lang }) {
  try {
    const lan = getLocaleOnly(lang);
    const url = `/wallet/transaction-details?transaction_id=${transactionId}&lang=${lan}`;
    const data = yield fetchClient({ url });
    return data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getTransactionByIdException",
      context: { tags: { journey: "checkout" }, extra: { transactionId } }
    });
  }
});

export {
  getTransactionById
};
//# sourceMappingURL=chunk-BH6MRFPJ.mjs.map